import { useProductImages } from '../hooks/useProductImages';

type ProductImageTagProps = {
	src: string;
};

const ProductImageTag = ({ src }: ProductImageTagProps) => {
	const { blockClass, maxHeight = 600 } = useProductImages();

	const renderClass = () => {
		return blockClass && `vtex-store-components-3-x-productImageTag--${blockClass}`;
	};

	return (
		<img
			className={`productImageTag productImageTag--${blockClass} vtex-store-components-3-x-productImageTag ${renderClass()}`}
			style={{
				width: '100%',
				height: '100%',
				maxHeight: maxHeight || 'unset',
				objectFit: 'contain',
			}}
			src={src}
			alt={'alt'}
			sizes="(max-width: 64.1rem) 100vw, 50vw"
		/>
	);
};

export default ProductImageTag;
